import { productMenuList } from "./productInfo";
import { solutionMenuList } from "./solutionInfo";

export type SiteConfig = typeof siteConfig

const transformKeywords = (list: any[]) => list.reduce((a, c) => (a.concat(...c.children.map((c1: any) => c1.title))), [] as string[])
export const siteConfig = {
  name: "赛讯信息官方网址",
  url: "https://www.cyberex.com.cn",
  description:
    "赛讯信息致力于网络与信息安全领域, 专注于安全·网络·5G的服务提供商",
  keywords: [
    '赛讯信息',
    ...transformKeywords(productMenuList),
    ...transformKeywords(solutionMenuList)
  ],
  mainNav: [
    { title: "首页", href: "/", key: "/", },
    {
      title: "产品",
      href: "/product/safe/zerotrust",
      key: "product",
      children: productMenuList
    },
    {
      title: "解决方案",
      href: "/solution/sase",
      key: "solution",
      children: solutionMenuList
    },
    {
      title: "服务与支撑",
      href: "/service",
      key: "service",
      children: [
        { title: "服务与支撑", href: "/service" },
      ]
    },
    {
      title: "关于我们",
      href: "/intro",
      key: "intro",
      children: [
        { title: "公司简介", href: "/intro" },
        { title: "人员招聘", href: "/intro/employ" },
        { title: "联系我们", href: "/intro/contact" },
      ]
    },
  ],
  links: {}
}

export enum NavType {
  "home" = "首页",
  "product" = "产品",
  "solution" = "解决方案",
  "service" = "服务与支持",
  "intro" = "关于我们",
}
export const siteNavMap = {
  [NavType.home]: siteConfig['mainNav'][0],
  [NavType.product]: siteConfig['mainNav'][1],
  [NavType.solution]: siteConfig['mainNav'][2],
  [NavType.service]: siteConfig['mainNav'][3],
  [NavType.intro]: siteConfig['mainNav'][4],
}


export const routeList = []

export const contactList = [
  {
    title: "全国统一服务热线",
    value: "400-008-5020"
  },
  {
    title: "销售支持",
    value: "sales@cyberex.com.cn"
  },
  {
    title: "技术支持",
    value: "support@cyberex.com.cn"
  }
]

export const companyInfoList = [
  {
    label: "公司总部",
    title: "广东省广州市越秀区寺右新马路108号丰伟大厦18A",
    subTitle: "丰伟大厦",
    loc: [113.303406, 23.12204],
  },
  {
    label: "研发中心",
    title: "武汉市江夏区经济开发区藏龙岛美加总部基地1202号",
    subTitle: "美加总部基地",
    loc: [114.42842, 30.431897],
  },
];
